var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.309V6.971c0-.536-.218-.971-.75-.971h-1.447c-.534 0-.803.435-.803.971v9.22l-1.719-2.059a1.046 1.046 0 00-.797-.367l-1 .019a.979.979 0 00-.84.477.97.97 0 00-.021.959l3.736 6.775a.96.96 0 00.844.504h6.387a.963.963 0 00.891-.6l1.521-6.68c0-.427-.185-.846-.59-.971L15.5 12.309zM2 1.5h2m-2 4h2m-2 4h2m3-8h2m-2 4h2m-2 4h2m3-8h2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
export default SvgSecurityCode;